module.exports = __webpack_public_path__ + "assets/blue-chat-bubble.4f563570.svg";